import { apiURL } from "../config";

class api {
  constructor() {
    this.token = localStorage.getItem("token");
  }

  getToken() {
    if (!this.token) {
      this.token = localStorage.getItem("token");
    }
    return this.token;
  }

  setToken(token) {
    this.token = token;
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  }

  getHeaders(contentType = true) {
    const h = { Authorization: `JWT ${this.token}` };
    if (contentType) h["Content-Type"] = "application/json";
    return h;
  }

  get(path) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${apiURL}${path}`, {
          mode: "cors",
          method: "GET",
          credentials: "include",
          headers: this.getHeaders(),
        });

        const res = await response.json();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  put(path, body) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${apiURL}${path}`, {
          mode: "cors",
          method: "PUT",
          credentials: "include",
          headers: this.getHeaders(),
          body: typeof body === "string" ? body : JSON.stringify(body),
        });

        const res = await response.json();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  postFormData(path, file) {
    let formData = new FormData();
    formData.append(file.name, file, file.name);
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${apiURL}${path}`, {
          mode: "cors",
          method: "POST",
          credentials: "include",
          headers: this.getHeaders(false),
          body: formData,
        });
        const res = await response.json();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  remove(path, body) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${apiURL}${path}`, {
          mode: "cors",
          credentials: "include",
          method: "DELETE",
          headers: this.getHeaders(),
          ...(body && { body: typeof body === "string" ? body : JSON.stringify(body) }),
        });
        const res = await response.json();
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  post(path, body) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${apiURL}${path}`, {
          mode: "cors",
          method: "POST",
          credentials: "include",
          headers: this.getHeaders(),
          body: typeof body === "string" ? body : JSON.stringify(body),
        });

        const res = await response.json();
        if (response.status !== 200) {
          return reject(res);
        }
        resolve(res);
      } catch (e) {
        reject(e);
      }
    });
  }

  download(path, body) {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await fetch(`${apiURL}${path}`, {
          mode: "cors",
          method: "POST",
          credentials: "include",
          headers: this.getHeaders(),
          body: typeof body === "string" ? body : JSON.stringify(body),
        });

        if (response.status !== 200) {
          return reject(response);
        }
        resolve(response);
      } catch (e) {
        reject(e);
      }
    });
  }

  async downloadFile(path) {
    const response = await fetch(`${apiURL}${path}`, {
      mode: "cors",
      method: "GET",
      credentials: "include",
      headers: { Authorization: `JWT ${this.getToken()}` },
    });

    if (!response.ok) {
      throw new Error(`HTTP error ${response.status}`);
    }

    const blob = await response.blob();
    const disposition = response.headers.get("Content-Disposition") || "";
    const utfMatch = disposition.match(/filename\*=UTF-8''([^;]+)/i);
    const asciiMatch = disposition.match(/filename="([^"]+)"/i);
    const fileName = utfMatch ? decodeURIComponent(utfMatch[1]) : asciiMatch ? asciiMatch[1] : "CV.pdf";
    return { blob, fileName };
  }

  async openpdf(path) {
    try {
      const response = await fetch(`${apiURL}${path}`, {
        mode: "cors",
        method: "GET",
        credentials: "include",
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        let errorMessage;
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || `HTTP error ${response.status}`;
        } catch (e) {
          errorMessage = `HTTP error ${response.status}`;
        }
        return Promise.reject(new Error(errorMessage));
      }

      const arrayBuffer = await response.arrayBuffer();
      return new Uint8Array(arrayBuffer);
    } catch (e) {
      console.error("PDF fetch error:", e);
      return Promise.reject(e);
    }
  }
}

const API = new api();
export default API;
